import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import CloudUploadSVG from "../../../../assets/images/icons/CloudUpload";
import ImageUploader from "../../../../components/common/ImageUploader/ImageUploader.tsx";
import { APPS } from "../../../../constants/AppsConstants.ts";
import { MAX_FILES_LIMIT } from "../../../../constants/ImageToImageConstants.ts";
import { useManualPlacementConfig } from "../../../../hooks/useManualPlacementConfig.ts";
import { useAppStore } from "../../../../hooks/useStores.tsx";
import iframeStore from "../../../IframeNew/iframe-store.tsx";
import styles from "./EmptyPlayground.module.scss";

interface IEmptyPlayground {
	header?: string;
	subHeader?: string;
	hideSubHeader?: boolean;
}

const EmptyPlayground = ({ header, subHeader, hideSubHeader = false }: IEmptyPlayground) => {
	const { t } = useTranslation("translation", { keyPrefix: "playground.emptyState" });
	const { playgroundStore, imageToImageStore, textToImageStore, authStore } = useAppStore();
	const { checkResolutions } = useManualPlacementConfig();

	const handleUpload = async (e: ChangeEvent<HTMLInputElement>) => {
		await imageToImageStore.handleUploadImages(e);
		checkResolutions();
	};

	return (
		<>
			{(playgroundStore.selectedConfig === APPS.IMAGE_TO_IMAGE ||
				playgroundStore.selectedConfig === APPS.AUTOMOTIVE) &&
			(!iframeStore.isIframe() || iframeStore.iframe.config.general_config?.enable_upload) ? (
				<Box className={styles.imageToImage}>
					<ImageUploader
						className={styles.imageUploader}
						emptyStateClassName={styles.emptyState}
						icon={<CloudUploadSVG />}
						showPreview={false}
						description={
							<Box className={styles.imageUploaderDesc}>
								<Box className={styles.header}>{header ?? t("header")}</Box>
								{!hideSubHeader && (
									<Box className={styles.subHeader}>{subHeader ?? t("subHeader")}</Box>
								)}
							</Box>
						}
						onUpload={(e) => handleUpload(e)}
						inputProps={{ multiple: true }}
						maxFilesLimit={MAX_FILES_LIMIT}
						loading={authStore.isLoadingOrgSubscriptions}
						disabled={
							authStore.isLoadingOrgSubscriptions ||
							authStore.orgPassedFreeLimit ||
							authStore.isSubscriptionInactive
						}
						// maxFileSize={MAX_FILE_SIZE}
					/>
				</Box>
			) : (
				<Box className={`${styles.textToImage}`}>
					{Array.from({ length: 4 }).map((_, _index) => (
						<Box
							width="25%"
							className={styles.skeleton}
							style={{
								aspectRatio: (textToImageStore.config.aspect_ratio ?? "1:1")?.replace(":", "/"),
							}}
							key={_index}
						></Box>
					))}
				</Box>
			)}
		</>
	);
};

export default observer(EmptyPlayground);
